// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum GroundTruthRunKind {
	Job = 0,
	Trial = 1,
}

export const GroundTruthRunKindDisplayNames: { [key in keyof typeof GroundTruthRunKind]?: string} = {
	"Job": "Job",
	0 : "Job",
	"Trial": "Trial",
	1 : "Trial",
}

export const getGroundTruthRunKindDisplayName = (key: GroundTruthRunKind | (keyof typeof GroundTruthRunKind & string)) => {
	return GroundTruthRunKindDisplayNames[key];
}

